import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { translate } from '@openclassrooms/translations';
import ContentDialog, { Props as ContentDialogProps } from '@classify/react-core-components/ContentDialog';
interface Props {
  isOpen: boolean;
  shouldDisplayBack: boolean;
  onClose: ContentDialogProps['onClose'];
  children: React.ReactNode;
}
export type PageType = 'main';
export function useDialog(t0) {
  const $ = _c(13);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isOpenDefault: t2,
    shouldHandleGlobalClick: t3
  } = t1;
  const isOpenDefault = t2 === undefined ? false : t2;
  const shouldHandleGlobalClick = t3 === undefined ? false : t3;
  const [isDialogOpen, setIsDialogOpen] = useState(isOpenDefault);
  const [currentPage, setCurrentPage] = useState(isOpenDefault ? "main" : undefined);
  const shouldDisplayBack = currentPage !== "main";
  let t4;
  let t5;
  if ($[2] !== shouldHandleGlobalClick) {
    t4 = () => {
      const handleFeedbackButtonClick = e => {
        const target = e.target as HTMLElement;
        if (!target) {
          return;
        }
        const link = target.closest("a");
        if (!link || link.href === "") {
          return;
        }
        const {
          hash
        } = new URL(link.href);
        if (hash.startsWith("#feedback")) {
          e.preventDefault();
          setIsDialogOpen(true);
        }
      };
      if (shouldHandleGlobalClick) {
        document.addEventListener("click", handleFeedbackButtonClick);
      }
      return () => {
        document.removeEventListener("click", handleFeedbackButtonClick);
      };
    };
    t5 = [shouldHandleGlobalClick];
    $[2] = shouldHandleGlobalClick;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setCurrentPage("main");
      setIsDialogOpen(true);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleOpen = t6;
  let t7;
  if ($[6] !== currentPage) {
    t7 = (event, cause) => {
      if (currentPage !== "main" && cause === undefined) {
        setCurrentPage("main");
        return;
      }
      setIsDialogOpen(false);
      setCurrentPage("main");
    };
    $[6] = currentPage;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const handleClose = t7;
  let t8;
  if ($[8] !== currentPage || $[9] !== handleClose || $[10] !== isDialogOpen || $[11] !== shouldDisplayBack) {
    t8 = {
      currentPage,
      isDialogOpen,
      handleOpen,
      handleClose,
      shouldDisplayBack
    };
    $[8] = currentPage;
    $[9] = handleClose;
    $[10] = isDialogOpen;
    $[11] = shouldDisplayBack;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
}
export default function FeedbackDialog(t0) {
  const $ = _c(6);
  const {
    isOpen,
    onClose,
    children,
    shouldDisplayBack
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      closeButtonLabel: translate("global.action.close_button")
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== isOpen || $[3] !== onClose || $[4] !== shouldDisplayBack) {
    t2 = <ContentDialog translations={t1} isSide={true} shouldForceDisplayBack={shouldDisplayBack} isOpen={isOpen} onClose={onClose} background="alternative">{children}</ContentDialog>;
    $[1] = children;
    $[2] = isOpen;
    $[3] = onClose;
    $[4] = shouldDisplayBack;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}